export const DEFAULT_HEARTBEAT_ENDPOINT = '/gateway/api/session/heartbeat';
export const DEFAULT_IDLE_TIME = 60 * 1000; // 60 seconds

export const INTERVAL_TIME = 10 * 1000; // 10 seconds
